import { MASK } from '../../../../constants/mask';
import SelectDc from '../../../../components/Selects/SelectDc';
import { isValidIban, normalizeIban } from '../../../../constants/kzBanks';

export const REQUISITES_FIELDS = {
  dcName: 'name',
  bin: 'bin',
  address: 'address',
  iban: 'iban',
  bankName: 'bankName',
  bic: 'bic',
};

// ÐÐ°Ð³Ð¾Ð»Ð¾Ð²Ð¾Ðº Ð±Ð»Ð¾ÐºÐ° ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÐ¾Ð²: ÐµÑÐ»Ð¸ Ð±ÑÐº Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð¸Ð» Ð¿Ð¾ÑÑÐµÐ´Ð½Ð¸ÐºÐ°, Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð²Ð¸Ð´ÐµÑÑ, ÑÑÐ¸ ÑÑÐ¾ ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ
// (Ð² Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐµ ÐÐ³ÐµÐ½ÑÐ¾Ð¼ Ð±ÑÐ´ÐµÑ Ð¾Ð½, Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ ÑÐµÑÐ²ÐµÑ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð¸Ñ Ð¸Ñ ÑÐ°Ð¼).
export const requisitesTitle = (viaIntermediary) =>
  viaIntermediary
    ? '4. Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ Ð¿Ð¾ÑÑÐµÐ´Ð½Ð¸ÐºÐ° (Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÐµÐ½Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸, ÑÐ¹Ð´ÑÑ Ð² Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ)'
    : '4. Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°';

// ÐÐ¾Ð½ÑÑÐ¾Ð»ÑÐ½ÑÑ ÑÑÐ¼Ð¼Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸ÐµÐ¼, Ð° Ð½Ðµ Ð¾ÑÐ¸Ð±ÐºÐ¾Ð¹: ÑÑÑÑ Ð±ÑÐ²Ð°ÐµÑ Ð½ÑÐ¶ÐµÐ½
// Ð¸ ÑÐ°ÐºÐ¾Ð¹, ÐºÐ°ÐºÐ¾Ð¹ Ð´Ð°Ð» ÐºÐ»Ð¸ÐµÐ½Ñ, Ð° Ð½Ð° ÑÐµÑÑÐµ Ð² Ð¿Ð¾Ð»Ñ Ð²Ð²Ð¾Ð´ÑÑ Ð·Ð°Ð²ÐµÐ´Ð¾Ð¼Ð¾ Ð²ÑÐ´ÑÐ¼Ð°Ð½Ð½ÑÐµ Ð½Ð¾Ð¼ÐµÑÐ°.
const ibanWarning = (values) => {
  const iban = normalizeIban(values?.iban);
  if (iban.length < 20) return undefined;
  return isValidIban(iban) ? undefined : 'ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð½Ð¾Ð¼ÐµÑ ÑÑÑÑÐ°: ÐºÐ¾Ð½ÑÑÐ¾Ð»ÑÐ½Ð°Ñ ÑÑÐ¼Ð¼Ð° Ð½Ðµ ÑÑÐ¾Ð´Ð¸ÑÑÑ';
};

export const REQUISITES_INPUTS = [
  {
    name: 'dcName',
    label: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°',
    placeholder: 'Ð¢ÐÐ Â«...Â»',
    rules: { required: true },
  },
  {
    name: 'bin',
    label: 'ÐÐÐ',
    placeholder: '000000000000',
    mask: MASK.IIN,
    rules: { required: true },
  },
  {
    name: 'address',
    label: 'Ð®ÑÐ¸Ð´Ð¸ÑÐµÑÐºÐ¸Ð¹ Ð°Ð´ÑÐµÑ',
    placeholder: 'Ð³. ÐÐ»Ð¼Ð°ÑÑ, ÑÐ». ...',
    rules: { required: true },
  },
  {
    name: 'iban',
    label: 'ÐÐ¾Ð¼ÐµÑ Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¾Ð³Ð¾ ÑÑÑÑÐ° (IBAN)',
    placeholder: 'KZ00000000000000000',
    mask: MASK.IBAN,
    warning: ibanWarning,
    rules: {
      required: true,
      validate: (value) => {
        const clean = (value || '').replace(/_/g, '');
        return clean.length === 20 || 'ÐÐ¾Ð¼ÐµÑ ÑÑÑÑÐ° Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ¾Ð´ÐµÑÐ¶Ð°ÑÑ 20 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²';
      },
    },
  },
  {
    name: 'bankName',
    label: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð±Ð°Ð½ÐºÐ°',
    placeholder: 'ÐÐ Â«ÐÐ°Ð½ÐºÂ»',
    rules: { required: true },
  },
  {
    name: 'bic',
    label: 'ÐÐÐ',
    placeholder: 'KCJBKZKX',
    maxLength: 8,
    transform: (value) => value?.toUpperCase(),
    rules: {
      required: true,
      validate: (value) => (value || '').replace(/_/g, '').length === 8 || 'ÐÐÐ Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ¾Ð´ÐµÑÐ¶Ð°ÑÑ 8 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²',
    },
  },
];

export const SELLER_REQUISITES_INPUTS = [
  {
    name: 'recipient',
    label: 'ÐÐ¾Ð»ÑÑÐ°ÑÐµÐ»Ñ',
    placeholder: 'Ð¤ÐÐ, ÐºÐ°Ðº Ð² Ð±Ð°Ð½ÐºÐµ',
    rules: { required: true },
  },
  {
    name: 'iban',
    label: 'IBAN Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°',
    placeholder: 'KZ000000000000000000',
    mask: MASK.IBAN,
    warning: ibanWarning,
    rules: {
      required: true,
      validate: (value) => {
        const clean = (value || '').replace(/[_ ]/g, '').toUpperCase();
        return /^KZ[0-9A-Z]{18}$/.test(clean) || 'ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½ÑÐºÐ¸Ð¹ IBAN â KZ Ð¸ 18 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²';
      },
    },
  },
  {
    name: 'bankName',
    label: 'ÐÐ°Ð½Ðº Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°',
    placeholder: 'ÐÐ Â«ÐÐ°Ð½ÐºÂ»',
    rules: { required: true },
  },
  {
    name: 'bic',
    label: 'ÐÐÐ / BIC Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°',
    placeholder: 'KCJBKZKX',
    maxLength: 11,
    transform: (value) => value?.toUpperCase(),
    rules: {
      required: true,
      validate: (value) => {
        const clean = (value || '').replace(/[_ ]/g, '').toUpperCase();
        return /^[A-Z]{8}([A-Z0-9]{3})?$/.test(clean) || 'ÐÐÐ â 8 Ð»Ð°ÑÐ¸Ð½ÑÐºÐ¸Ñ Ð¸Ð»Ð¸ SWIFT Ð½Ð° 11';
      },
    },
  },
];

/**
 * ÐÑÐ¾Ð´Ð°Ð²ÐµÑ ÑÐµÑÐ¾Ð³Ð¾ Ð´Ð¸Ð»ÐµÑÐ° â ÑÐ°Ð¼ ÐÐ¦: Ð¾Ð´Ð¸Ð½ ÑÐµÐ»ÐµÐºÑ Ð²Ð¼ÐµÑÑÐ¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ° CRM. ÐÑÐ±Ð¾Ñ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÑÐµÑ ÑÑÑÑ ÐÐ¦
 * (ÑÐ¼. sellerAccountOf), Ð° Ð°Ð³ÐµÐ½ÑÐ¾Ð¼ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ° Ð¾ÑÑÐ°ÑÑÑÑ Ð¿Ð¾ÑÑÐµÐ´Ð½Ð¸Ðº ÐºÐ¾Ð½ÑÑÑÐ° â ÐµÐ³Ð¾ Ð±ÑÐº Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð¸Ñ ÑÐ°Ð¼.
 */
export const buildSellerDcInput = ({ onChange, used }) => ({
  name: 'dc',
  component: SelectDc,
  label: 'ÐÑÐ¾Ð´Ð°Ð²ÐµÑ â Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ',
  placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
  isMulti: false,
  used: used || undefined,
  rules: { required: true },
  onChangeCustom: onChange,
});

/** Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐÐ³ÐµÐ½ÑÐ° Ð¸Ð· Ð¾ÑÐ²ÐµÑÐ° getDcRequisites â Ð² ÑÐ¾Ð¹ ÑÐ¾ÑÐ¼Ðµ, ÑÑÐ¾ ÑÑÐ¾Ð´Ð¸Ñ Ð² createConsignment. */
export const agentRequisitesOf = (res) =>
  Object.fromEntries(Object.entries(REQUISITES_FIELDS).map(([field, key]) => [field, res?.[key] ?? '']));

/** Ð¡ÑÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°-ÐÐ¦ Ð¸Ð· ÐµÐ³Ð¾ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÑ ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÐ¾Ð² (res.own Ð² getDcRequisites); Ð±ÐµÐ· Ð½Ð¸Ñ â Ð¿ÑÑÑÐ¾. */
export const sellerAccountOf = (own) => ({
  recipient: own?.name ?? '',
  iban: own?.iban ?? '',
  bankName: own?.bankName ?? '',
  bic: own?.bic ?? '',
});

/**
 * Ð¡Ð¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐ¹ ÐÐ¦ ÑÐµÑÐ¾Ð³Ð¾ Ð´Ð¸Ð»ÐµÑÐ° Ð´Ð»Ñ Ð°Ð²ÑÐ¾Ð²ÑÐ±Ð¾ÑÐ°: ÐµÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð² ÑÐ¿Ð¸ÑÐºÐµ, Ð½Ðµ ÑÑÐ¸ÑÐ°Ñ Ð¿Ð¾ÑÑÐµÐ´Ð½Ð¸ÐºÐ° (ÐÑÐ¸Ð»Ñ).
 * ÐÐµÑÐºÐ¾Ð»ÑÐºÐ¾ â Ð²ÑÐ±Ð¸ÑÐ°ÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ; Ð½Ð¸ Ð¾Ð´Ð½Ð¾Ð³Ð¾ â ÑÐ¾Ð¶Ðµ: ÑÐµÐ»ÐµÐºÑ Ð¾ÑÑÐ°ÑÑÑÑ Ð½Ð° ÑÐºÑÐ°Ð½Ðµ.
 */
export const autoSellerDc = (list) => {
  const own = (Array.isArray(list) ? list : []).filter((dc) => !dc?.isIntermediary);
  return own.length === 1 ? { value: own[0].id, label: own[0].name, cityId: own[0].cityId } : null;
};

/** Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐÐ³ÐµÐ½ÑÐ° Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼ â ÑÐ¾Ð³Ð´Ð° Ð±Ð»Ð¾Ðº Â«Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐÐ¦Â» Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½Ðµ Ð½ÑÐ¶ÐµÐ½. */
export const agentRequisitesComplete = (requisites) =>
  Object.keys(REQUISITES_FIELDS).every((field) => String(requisites?.[field] ?? '').trim());

/** Ð¡ÑÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°-ÐÐ¦ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼ â Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ ÐµÐ³Ð¾ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð½ÐµÐ·Ð°ÑÐµÐ¼. */
export const sellerAccountComplete = (own) => Object.values(sellerAccountOf(own)).every((value) => String(value).trim());

/** ÐÐ¾Ð»Ñ ÑÑÑÑÐ° ÑÐ±Ð¸ÑÐ°ÐµÐ¼ Ñ ÑÐºÑÐ°Ð½Ð°, Ð½Ð¾ Ð¾ÑÑÐ°Ð²Ð»ÑÐµÐ¼ Ð² ÑÐ¾ÑÐ¼Ðµ: Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ ÐÐ¦ ÑÑÐ¾Ð´ÑÑ Ð² ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ðµ. */
export const hideInputs = (inputs, hidden) =>
  hidden ? inputs.map((input) => ({ ...input, style: { ...input.style, display: 'none' } })) : inputs;

export const sellerFio = (seller) => {
  const client = seller?.client || seller;
  if (!client) return seller?.label || '';
  return [client.surname, client.name, client.middlename].filter(Boolean).join(' ').trim();
};

export const withDefaults = (inputs, values) =>
  inputs.map((item) => ({ ...item, defaultValue: values?.[item.name] ?? '' }));

export const cleanBank = (value) =>
  String(value || '')
    .replace(/[_ ]/g, '')
    .toUpperCase();
